export const USER_ACTIONS_MENU_WRAPPER_TEST_ID = 'user-actions-menu-wrapper'

export const USER_ACTIONS_MENU_TRIGGER_TEST_ID = 'user-actions-menu-trigger'

export const USER_ACTIONS_MENU_DROPDOWN_TEST_ID = 'user-actions-menu-dropdown'

export const USER_ACTIONS_MENU_DROPDOWN_CONTENT_TEST_ID = 'user-actions-menu-dropdown-content'

export const CREATE_ORGANIZATION_ACTON_TEST_ID = 'create-organization-action'
